t = require('views/internal/teacup-with-helpers')('list')

module.exports = t.renderable ({ name, subscribed, loggedIn, hasTriggeredFullView, index }) ->

  t.div '.list.js-list-content', ->

    headerClasses =
      'list-header': true
      'js-list-header': true
      'u-clearfix': true
      'is-menu-shown': loggedIn
      'is-subscribe-shown': subscribed

    t.div { class: t.classify(headerClasses) }, ->

      inputClasses =
        'list-header-name': true
        'mod-list-name': true
        'js-list-name-input': true

      t.div '.list-header-target.js-editing-target'

      t.h2 '.list-header-name-assist.js-list-name-assist', { dir: 'auto' }, name

      t.textarea { class: t.classify(inputClasses), 'aria-label': name, spellcheck: 'false', dir: 'auto', maxLength: 512 }, name

      if hasTriggeredFullView
        t.div '.list-header-extras', ->

          subscribeClasses =
            'list-header-extras-subscribe': true
            'js-list-subscribed': true

          if !subscribed
            subscribeClasses['hide'] = true

          t.span { class: t.classify(subscribeClasses) }, ->
            t.span '.icon-lg.icon-subscribe'

          if loggedIn
            t.a '.list-header-extras-menu.dark-hover.js-open-list-menu.icon-lg.icon-overflow-menu-horizontal', {
              href: '#'
            }, ->
              t.div()

      t.p '.list-header-num-cards.hide.js-num-cards'

    t.a '.open-card-composer.js-open-card-composer', { href: '#' }, ->
      t.icon 'add'
      t.span '.js-add-a-card', ->
        t.format 'add-a-card'
      t.span '.js-add-another-card.hide', ->
        t.format 'add-another-card'

  if index == 0
    t.div '.guided-tour-tooltip.guided-tour-tooltip-card-front.js-guided-tour-tooltip.js-tool-tip-card-front.hide', ->
      t.div '.guided-tour-tooltip-pointer'
      t.div '.guided-tour-tooltip-body', ->
        t.h3 ->
          t.format 'create-your-first-card'
        t.format 'click-here-to-create-a-card'
    t.div '.guided-tour-tooltip.guided-tour-tooltip-card-back.js-guided-tour-tooltip.js-tool-tip-card-back.hide', ->
      t.div '.guided-tour-tooltip-pointer'
      t.div '.guided-tour-tooltip-body', ->
        t.h3 ->
          t.format 'open-a-card-to-add-details'
        t.format 'click-anywhere-on-a-card-to-open-it-and-add-information-to-it'
  else if index == 1
    t.div '.guided-tour-tooltip.guided-tour-tooltip-list.js-guided-tour-tooltip.js-tool-tip-list.hide', ->
      t.div '.guided-tour-tooltip-pointer'
      t.div '.guided-tour-tooltip-body', ->
        t.h3 ->
          t.format 'make-lists-your-own'
        t.format 'click-on-a-list-title-to-rename-it-or-click-and-drag'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/list.coffee